import { useRef } from "react";
import { ILoggedInStatus } from "../../LoggedInStatus";
import { useCreateNewRemortgage, usePreviousStatus } from "./queriesAndMutations";

export const useGetOnSubmit = (contactId: string, status: ILoggedInStatus, applicationId?: string) => {
  const createRemo = useCreateNewRemortgage();
  const [getStatus] = usePreviousStatus();
  const isSubmitting = useRef(false);
  return async () => {
    if (!isSubmitting.current) {
      isSubmitting.current = true;
      if (status === ILoggedInStatus.LOGGED_IN) {
        if (applicationId) {
          const { data } = await getStatus({ variables: { applicationId } });
          const status = data?.applicationDetails?.status;
          const shouldAllowCreatingNewApplication = ["CLOSED", "COMPLETION", "EXCHANGE"].includes(status || "");
          if (shouldAllowCreatingNewApplication) {
            await createRemo({ variables: { userId: contactId } });
            window.location.assign(`${FACTFIND_HOST}/profile/application`);
          } else {
            window.location.assign(`${AUTH_UI_URL}/login/confirmed`);
          }
        } else {
          await createRemo({ variables: { userId: contactId } });
          window.location.assign(`${FACTFIND_HOST}/profile/application`);
        }
      } else {
        window.location.assign(`${AUTH_UI_URL}/signup?application=eyJwdXJjaGFzaW5nUHVycG9zZSI6IlJFTU9SVEdBR0UiLCJkZWFsRW5kIjoiZW5kZWQifQ==`);
      }
      isSubmitting.current = false;
    }
  };
};
